{
  "languages": {
    "arabic": "Arabų",
    "belarusian": "Baltarusių",
    "chinese": "Kinų",
    "dutch": "Olandų",
    "english": "Anglų",
    "french": "Prancūzų",
    "german": "Vokiečių",
    "italian": "Italų",
    "japanese": "Japonų",
    "korean": "Korėjiečių",
    "lithuanian": "Lietuvių",
    "portuguese": "Portugalų",
    "romanian": "Rumunų",
    "spanish": "Ispanų",
    "turkish": "Turkų"
  }
}
